import {
  base_colorAction,
  base_colorActionHover,
  base_colorAlert,
  base_contentHover,
  cta_buttonSecondaryBackground,
  grey400,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { transition_fast } from 'ext-ui/style/transitionSpeeds'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_lg,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  border: none;

  legend {
    font-family: ${font_family_weight_regular};
    ${font_md}
    margin-bottom: ${spacing(2)};
    color: ${text_colorTextSecondary};
  }

  .RadioGroup--buttons {
    display: flex;
    flex-direction: column;
    gap: ${spacing(2)};

    label.RadioButton {
      display: grid;
      grid-template-columns: min-content 1fr;
      gap: ${spacing(3)};
      padding: ${spacing(5)};

      border: 1px solid ${grey400};
      border-radius: ${spacing(2)};

      .RadioButton--extra-content {
        grid-column: 2;
        /* Gets overriden later. */
        display: none;
      }

      & .RadioButton--title {
        font-family: ${font_family_weight_medium};
        ${font_lg}
        margin-bottom: ${spacing(1)};

        color: ${text_colorTextPrimary};
        transition: color ${transition_fast} ease-in-out;
      }

      & .RadioButton--desc {
        font-family: ${font_family_weight_regular};
        ${font_sm}
        color: ${text_colorTextSecondary};
      }

      & > input {
        appearance: none;

        width: ${spacing(5)};
        height: ${spacing(5)};
        padding: 1px;

        transition-property: background-color, border-color;
        transition-duration: ${transition_fast};
        transition-timing-function: ease-in-out;

        background-color: ${cta_buttonSecondaryBackground};
        border: 1px solid ${grey400};
        border-radius: ${spacing(5)};

        &:checked {
          background-color: ${base_colorAction};
          /* Clip background to content, ignoring padding */
          background-clip: content-box;
          border-color: ${base_colorAction};
        }

        &:invalid {
          border-color: ${base_colorAlert};
        }

        &:not(:disabled) {
          box-shadow: 0px 1px 3px 0px #00000026;
          &:hover,
          &:focus-visible {
            border-color: ${base_colorActionHover};
            &:checked {
              background-color: ${base_colorActionHover};
            }
          }
        }
      }

      &:not(:has(> input:disabled)) {
        /* Show the colored bg whenever any child is focused */
        &:hover,
        &:has(:focus-visible) {
          background-color: ${base_contentHover};
        }

        /* Show the extra outline only for the *radio* input, not all children */
        &:has(> input:focus-visible) {
          outline: 1px solid ${base_colorActionHover};
        }

        /* Checked styles */
        &:has(> input:checked) {
          border-color: ${base_colorAction};
          .RadioButton--title {
            color: ${base_colorAction};
          }
          .RadioButton--extra-content {
            display: block;
          }
        }

        /* Hover styles */
        &:has(> input:hover, > input:focus-visible) {
          .RadioButton--title {
            color: ${base_colorActionHover};
          }
        }
      }

      &:has(> input:disabled) {
        opacity: 0.4;
      }
    }
  }
`
